<template>
  <b-modal
    id="xero-not-connected-modal"
    ref="xero-not-connected-modal"
    size="lg-size"
    modal-class="modal-xero"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">{{ "Integration Not Available!" }}</h2>
      <div class="quickbooks-logo">
        <img
          src="/assets/images/xero-logo-blue.svg"
          alt="Atto"
          class="black-logo"
          width="50"
          height="50"
        />
      </div>
    </div>
    <div class="content-wrapper">
      <p>
        {{
          "Atto currently integrates to Xero accounts in Australia and the United Kingdom only. An integration with your account type is not available."
        }}
      </p>
      <p>
        {{
          "If you’d like us to expand our integration, please contact us at support@attotime.com with additional details."
        }}
      </p>
    </div>
    <div class="modal-footer">
      <button
        type="reset"
        class="atto-btn close-btn"
        data-dismiss="modal"
        @click="close"
      >
        {{ label.get("close") }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import CompanyService from "../services/CompanyService";
import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";

export default {
  name: "XeroNotConnectedModalComponent",
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs["xero-not-connected-modal"].show();
  },
  methods: {
    close() {
      let query = Object.assign({}, this.$route.query);
      delete query.xeroNotConnected;
      this.$router.replace({ query });
      this.$root.$emit("hideXeroNotConnectedModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-entry-delete {
  .modal-content {
    .modal-body {
      .content-wrapper {
        &.password-confirm.has-error {
          padding-bottom: 16px;
        }
      }
    }
  }
}
.modal-xero {
  .content-wrapper {
    padding-top: 0;
    flex-flow: column;
    padding-bottom: 0;
    p {
      max-width: 480px;
      width: 100%;
      color: #666666;
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
  }
}

.password-confirm {
  p {
    margin-bottom: 12px !important;
    text-align: left !important;
  }

  input {
    width: 100%;
    border: 2px solid #efefef;
    padding: 5px 10px;
    font-family: "Roboto", sans-serif;
    line-height: 36px;
    color: #262626;

    &:focus {
      border-color: #00b9cb;
    }
  }
}
</style>
